<template>
  <div>
    <mdb-parallax
      src="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fbackground3.png?alt=media&token=9cfe5624-8eec-4f89-a912-8d44a6d89cc5"
      height="full"
      factor="2"
      alt="header"
    >
      <mdb-mask
        overlay="purple-slight"
        color="#33b5e5"
        class="d-flex justify-content-center align-items-center"
      >
        <mdb-container class="text-white">
          <mdb-row class="mt-5 pt-5">
            <mdb-col md="12" class="text-center animated fadeInUp">
              <div id="logosection">
               <img id="logo" class="text-center" src="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Flogo%2Fprint_4c_transportpng.png?alt=media&token=aaeb89c5-5950-4bd0-bf0c-635d8ba2492a">
               </div>
              <h5
                id="h5" class="mb-5 pt-md-5 pt-sm-2 pt-5 pb-md-5 pb-sm-3 pb-5"
              > Ob Klassiker, Muscle-Car, Sportwagen, Off-Roader oder Truck, fette Harley oder schneidiges Sportboot. Kaufen Sie Ihr Traumfahrzeug direkt in den USA, ganz bequem von zu Hause aus ….</h5>
              <mdb-btn v-scroll-to="'#preislisteid'" color="blue" rounded icon="user">Preisliste anfordern</mdb-btn>
              <mdb-btn v-scroll-to="'#Service'" outline="blue" rounded to="/#Service">mehr erfahren</mdb-btn>
            </mdb-col>
          </mdb-row>
        </mdb-container>
      </mdb-mask>
    </mdb-parallax>

  </div>
</template>

<script>
import {
  mdbContainer,
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbInput,
  mdbParallax,
  mdbMask,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbSideNav,
  mdbSideNavNav,
  mdbSideNavCat,
  mdbSideNavItem,
  mdbIcon,
  waves
} from "mdbvue";

export default {
  name: "headersection",
  components: {
    mdbContainer,
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbInput,
    mdbMask,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbParallax,
    mdbSideNav,
    mdbSideNavNav,
    mdbSideNavCat,
    mdbSideNavItem,
    mdbIcon,
    waves
  },
  data() {
    return {
      toggle: false
    };
  },
  mixins: [waves]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

#bars {
  padding-top: 0.5rem;
  padding-right: 1rem;
  width: 40px;
}
#logo {
  padding-bottom: 4rem;
  width: 50rem;
    display: flex;
  justify-content: center;
}
#logosection {
  display: flex;
  justify-content: center;
  padding-right: 3rem;
}
.top-nav-collapse {
  background-color: #1976d2 !important;
}

.navbar-toggler-icon {
  color: white;
}
/* .view {
  background: url("https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fbackground3.png?alt=media&token=9cfe5624-8eec-4f89-a912-8d44a6d89cc5")
    no-repeat center center;
  background-size: cover;
  height: 100%;
}
*/

@media (min-device-width: 800px) {
.side-nav .collapsible a, .fas .far {
  font-size: 2rem;
  height: 3rem;
}
}


body {
  background-color: #141414;
  color: #efefef;
}

body h2, h1 {
  font-size: 4rem;
  color: #2196f3 !important;
}

#baricon {
  display: flex;
  flex-direction: row;
}

.btn-blue {
  background-color: rgba(223, 7, 28, 0.9) !important;
}

.btn-outline-blue {
    border: 2px solid rgba(223, 7, 28, 0.9) !important;
}

#h5 {
  font-size: 1.8rem;
  font-weight: 500;
  letter-spacing: 150%;
  word-spacing: 150%;
  line-height: 3rem;
  text-shadow: 1px 1px 1px #000;
}

.side-nav.wide {
  width: 75%;
}

span,
a {
  color: white !important;
}
.ripple-parent,
.nav-link a {
  color: white !important;
}

#white-mod {
  color: white !important;
}

  /* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 500px) { 
   #logo { 
    width: 25rem !important;
   }
   #h5 {
  font-size: 1rem;
}
}

</style>